<template>
  <div id="data-view">
    <div class="full-container">
      <top-header />
      <div class="main-content">
        <baidu-map ref="baiduMap"></baidu-map>
        <div class="floats">
          <div class="float-pane top">
            路段名称：<select v-model="projectId" @change="loadProject(projectId)">
              <option v-for="project in projects" :value="project.id">{{ project.name }}</option>
            </select>
          </div>
          <div class="float-pane left">
            <div class="pane-item segment">
              <div class="title">筋材应变（单位：%）</div>
              <div class="content">
                <sensor-history-chart ref="shc"></sensor-history-chart>
              </div>
            </div>
            <div class="pane-item segment">
              <div class="title">筋材应变的变化率（单位：%/秒）</div>
              <div class="content">
                <sensor-history-derivative-chart ref="shdc"></sensor-history-derivative-chart>
              </div>
            </div>
          </div>
          <div class="float-pane right">
            <div class="pane-item segment">
              <div class="title">切面详情</div>
              <div class="content">
                <a class="link" href="#" v-for="segment in segments" @click="loadSegment(segment.segment_id)">{{ segment.name }}</a>
              </div>
            </div>
            <div class="pane-item live">
              <div class="title">{{ currentSegment.live_type =='stream'? '实时视频':'实景照片'}}</div>
              <div class="content img">
                <flv-video v-if="currentSegment.live_type == 'stream'" :videoUrl="currentSegment.live_stream_url"></flv-video>
                <img v-if="currentSegment.live_type == 'photo'" :src="currentSegment.live_photo_url" />
              </div>
            </div>
            <div class="pane-item chart">
              <div class="title">土工带形变量</div>
              <div class="content ">
                <hot-chart ref="hotChart" @sensor-click="handleSensorClick"></hot-chart>
              </div>
            </div>
            <!-- <div class="pane-item">
              <div class="title">地形图</div>
              <div class="content">
                <flv-video></flv-video>
              </div>
            </div> -->
          </div>
          <!-- <div class="float-pane bottom">
            111哈哈哈1
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import topHeader from './topHeader'
import baiduMap from './baiduMap.vue'
import flvVideo from './flvVideo.vue'
import hotChart from './hotChart.vue'
import sensorHistoryChart from './sensorHistoryChart.vue'
import sensorHistoryDerivativeChart from './sensorHistoryDerivativeChart.vue'
export default {
  name: 'DataView',
  components: {
    topHeader,
    baiduMap,
    flvVideo,
    hotChart,
    sensorHistoryChart,
    sensorHistoryDerivativeChart
  },
  data() {
    return {
      projectId: null,
      segmentId: null,
      currentSegment: {},
      projects: [

      ],
      segments: [

      ]
    }
  },
  methods: {
    handleSensorClick(sensor) {
      console.log('Parent handleSensor Click', sensor)
      const that = this;
      that.$refs.shc.initChart(sensor);
      that.$refs.shdc.initChart(sensor);
    },  
    go(lng, lat,level) {
      this.$refs.baiduMap.go(lng, lat,level);
    },
    loadProject(projectId) {
      const that = this;
      const projectFound = this.projects.filter(project => project.id === projectId );
      if (projectFound.length > 0) {
        console.log('Found Project', projectId)
        this.projectId = projectId;
        api.get(`/projects/${projectId}/segments`).then(response => {
          that.segments = response.data.data;
          that.$refs.baiduMap.setSegments(that.segments);
          that.loadSegment(that.segments[0].segment_id)
        })
      }
    },
    loadSegment(segmentId) {
      const that = this;
      const segmentFound = this.segments.filter(segment => segment.segment_id === segmentId);
      if (segmentFound.length > 0) {
        that.segmentId = segmentId;
        const segment = segmentFound[0];
        that.currentSegment = segment;
        // 百度地图定位
        that.go(segment.longitude, segment.latitude, 20)
        that.$refs.hotChart.setSegmentId(segmentId);
      } else {
        that.$refs.hotChart.clearSegmentId();
      }
    }
  },
  mounted() {
    api.get('/projects')
    .then(response => {
      this.projects = response.data.data;
      if (this.projects && this.projects.length > 0) {
        this.loadProject(this.projects[0].id)
      }
    })
  }
}
</script>
<style lang="less" scoped>
select:focus {
  outline: none;
}

select {
  width: 300px;
  background: rgba(0, 0, 0, 0);
  border: 0;
  font-size: 18px;
  color: white;
  z-index: 1000;
  cursor: pointer;
}

option {
  color: black;
  font-size: 16px;
  cursor: pointer;
}

#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  .full-container{
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    background-color: black;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .floats {
    position: absolute;
    width: calc(100% - 2px);
    height: calc(100vh - 100px);
  }

  .float-pane {
    background-color: rgba(6, 30, 93, 0.9);
    position: absolute;
    display: flex;
  }

  .float-pane.top {
    width: 60%;
    height: 50px;
    line-height: 50px;
    padding-left: 420px;
    background: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .float-pane.right {
    z-index: 1000;
    right: 0px;
    width: 25%;
    height: calc(100vh - 100px);
    flex-direction: column;
    text-align: left;
  }
  .float-pane.left {
    z-index: 1000;
    left: 0px;
    width: 400px;
    height: calc(100vh - 100px);
    flex-direction: column;
    text-align: left;
  }

  .pane-item {
    padding: 0 20px;
    margin: 5px 0;
    height: calc( (100vh - 100px) / 3) ;
    display: flex;
    flex-direction: column;
  }

  .pane-item.segment {
    flex: 1;
  }

  .pane-item.live {
    flex: 5;
  }
  .pane-item.chart {
    flex: 5;
  }

  .pane-item .title {
    border-bottom: 2px solid rgba(12, 60, 93, 1);
    padding: 2px 0;
    user-select: none;
  }

  .pane-item .content {
    padding: 10px 0;
    flex: 1;
  }

  .pane-item .content .link {
    margin-right: 20px;
  }

  // .float-pane.left {
  //   left: 0;
  //   width: 15%;
  //   height: 100%;
  // }
  .float-pane.bottom {
    left: 0;
    bottom: 100px;
    width: 85%;
    height: 15%;
  }

  .link,
  .link:visited {
    text-decoration: none;
    font-size: 12px;
    color: #36f;
  }
  .content.img {
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .content.img img {
    max-height: calc((100vh - 100px) / 3 - 50px);
    max-width: 100%;
  }
}
</style>
